import { compile, tryCompileFromBase64 } from '../bpl/compiler.js'
import { getPageUrl } from '../page-url.js'

import { defaultWall as defaultSource } from './default.js'
import { stackWall as stackSource } from './stack.js'
import { englishWall as englishSource } from './english.js'
import { flemishWall as flemishSource } from './flemish.js'
import { commonWall as commonSource } from './common.js'
import { monochromeWall as monoSource } from './monochrome.js'
import { randomWall as randomSource } from './random.js'
import { graphpaperWall as graphpaperSource } from './paper/graphpaper.js'
import { linedpaperWall as linedpaperSource } from './paper/linedpaper.js'

const checkerboardSource = `\
-- checkerboard

@unit 20px
@height 20px
@gap 0px
@shadow none

R = 1 #000000
W = 1 #FFFFFF

R W
W R
`

const gradientSource = `\
-- color gradient strip

@unit 20px
@height 20px
@gap 1px
@shadow none

A = 1 #FF3EAF
B = 1 #FF0000
C = 1 #FF5500
D = 1 #FFAA00
E = 1 #FFFF00

A B C D E
`

const presets = {
  default: defaultSource,
  stack: stackSource,
  english: englishSource,
  flemish: flemishSource,
  common: commonSource,
  mono: monoSource,
  random: randomSource,
  graphpaper: graphpaperSource,
  linedpaper: linedpaperSource,
  checkerboard: checkerboardSource,
  gradient: gradientSource,
}

export const loadWall = (wall) => {
  const url = getPageUrl()
  if (!wall) {
    wall = url.searchParams.get('w')?.trim() || 'default'
  }

  url.searchParams.set('w', wall)
  window.history.replaceState(null, null, url.toString())

  if (presets[wall]) {
    console.debug(`Loading BPL preset: ${wall}`)
    window.document.title = `bricks | ${wall}`
    const config = compile(presets[wall])
    config._bplSource = presets[wall]
    return config
  }

  console.debug('Parsing custom BPL wall')
  window.document.title = 'bricks | custom'

  try {
    if (wall.startsWith('b64:')) {
      return tryCompileFromBase64(wall.slice(4))
    }
    return tryCompileFromBase64(wall)
  } catch (e) {
    console.error('Failed to parse custom wall, falling back to default:', e.message)
    window.document.title = 'bricks | default'
    return compile(defaultSource)
  }
}

export const getPresetNames = () => Object.keys(presets)

export const getPresetSource = (name) => presets[name] || null
